import React, { useContext, useEffect, useState } from "react";
import { Grid, Paper, TextField, Divider, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

// Contexts
import FacebookProfilesDashboardContext from "../../../../context/facebook_profiles/dashboard/DashboardContext";
import FacebookCampaignContext from "../../../../context/facebook_profiles/campaign/CampaignContext";

// Components
import Form from "./Form";
import CancelAlert from "./CancelAlert";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginBottom: "1rem",
    marginLeft: "8px",
    height: 700,
  },
  paperBox: {
    padding: "0.5rem",
  },
  row: {
    width: "100%",
  },
  divider: {
    width: "100%",
    paddingTop: "1rem",
    paddingBottom: "1rem",
  },
  rowForm: {
    height: 500,
  },
  buttonBox: {
    textAlign: "center",
    marginLeft: "0.5rem",
  },
  button: {
    textTransform: "none",
    "&:focus": {
      outline: "none",
    },
  },
}));

const CreateCampaign = () => {
  const classes = useStyles();

  const { selected_fb_details, selected_profile, setDisplayContent } =
    useContext(FacebookProfilesDashboardContext);
  const {
    form_details,
    setFormDetails,
    form_errors,
    setFormErrors,
    resetForm,
    createCampaign,
  } = useContext(FacebookCampaignContext);

  const [bm, setBm] = useState();
  const [ad, setAd] = useState();
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    selected_profile.bm_account.map((bm) => {
      if (bm.bm_account_id === selected_fb_details.business_manager) {
        setBm(bm);
      }
    });

    selected_profile.ad_account.map((ad) => {
      if (ad.ad_account_id === selected_fb_details.ad_account) {
        setAd(ad);
      }
    });
  }, []);

  const modalClose = () => {
    // Continue Edit Ad Set
    setModalOpen(false);
  };

  const modalSave = () => {
    // Back To Overview
    setDisplayContent();
    resetForm();
  };

  const onCancel = () => {
    // Open Modal - Cancel Creation
    setModalOpen(true);
  };

  const onCreate = (e) => {
    e.preventDefault();

    let next = true;

    Object.values(form_errors).map((err) => {
      if (err) next = false;
    });

    Object.entries(form_details).map(([id, val]) => {
      if (id === "special_ad_categories") {
        if (val.length === 0) {
          form_errors[id] = "Special Ad Categories cannot be empty!";
          next = false;
        }
      } else {
        let name;

        if (id === "name") name = "Name";
        else if (id === "daily_budget") name = "Daily Budget";
        else if (id === "status") name = "Status";
        else if (id === "objective") name = "Objective";
        else if (id === "bid_strategy") name = "Bid Strategy";

        if (val === "") {
          form_errors[id] = `${name} cannot be empty!`;
          next = false;
        }
      }
    });

    setFormDetails(form_details);
    setFormErrors(form_errors);

    if (next) createCampaign(selected_profile.profile_id, ad.ad_account_id);
  };

  return (
    <Paper className={classes.paper}>
      <CancelAlert
        modalOpen={modalOpen}
        modalClose={modalClose}
        modalSave={modalSave}
      />
      <Grid
        container
        className={classes.paperBox}
        justifyContent="space-between"
        alignItems="flex-start"
      >
        <Grid item className={classes.row}>
          <Grid item xs={4} container direction="column" spacing={1}>
            <Grid item>
              <TextField
                fullWidth
                disabled
                size="small"
                margin="dense"
                label="Business Manager"
                id="business_manager"
                name="business_manager"
                value={bm ? `${bm.bm_account_name} (${bm.bm_account_id})` : ""}
              />{" "}
            </Grid>
            <Grid item>
              <TextField
                fullWidth
                disabled
                size="small"
                margin="dense"
                label="Ad Account"
                id="ad_account"
                name="ad_account"
                value={ad ? `${ad.ad_account_name} (${ad.ad_account_id})` : ""}
              />{" "}
            </Grid>{" "}
          </Grid>{" "}
        </Grid>
        <Grid item className={classes.divider}>
          <Divider variant="fullWidth" />
        </Grid>
        <Grid item className={classes.rowForm}>
          <Form />
        </Grid>
        <Grid
          item
          className={classes.row}
          container
          justifyContent="flex-end"
          alignItems="center"
        >
          <Grid item className={classes.buttonBox}>
            <Button
              fullWidth
              variant="contained"
              color="secondary"
              className={classes.button}
              onClick={onCancel}
            >
              Cancel{" "}
            </Button>{" "}
          </Grid>
          <Grid item className={classes.buttonBox}>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              className={classes.button}
              onClick={onCreate}
            >
              Next{" "}
            </Button>{" "}
          </Grid>{" "}
        </Grid>{" "}
      </Grid>{" "}
    </Paper>
  );
};

export default CreateCampaign;
